import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-menu" };
const _hoisted_4 = { class: "float-end float-start-sm mt-2" };
const _hoisted_5 = { class: "form-contents" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-7" };
const _hoisted_8 = { class: "input-group top_search" };
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_11 = { class: "col-sm-12 col-md-2 ps-0" };
const _hoisted_12 = { class: "x_panel" };
const _hoisted_13 = { class: "x_content p-0 mt-0" };
const _hoisted_14 = { class: "report-list-options" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { style: { "margin-top": "4px", "margin-bottom": "4px" } };
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-5 ps-0" };
const _hoisted_18 = { class: "x_panel" };
const _hoisted_19 = { class: "x_content p-0 mt-0" };
const _hoisted_20 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_21 = {
    class: "col-xs-12 col-sm-12 col-md-12",
    style: { "border": "1px solid #ced4da" }
};
const _hoisted_22 = { class: "checkbox-wrapper" };
const _hoisted_23 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_24 = {
    class: "clearfix",
    style: { "border": "1px solid #ced4da" }
};
const _hoisted_25 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_26 = { class: "d-flex justify-content-end w-100" };
const _hoisted_27 = { class: "d-flex" };
const _hoisted_28 = { class: "mb-0 pt-2" };
const _hoisted_29 = ["disabled"];
const _hoisted_30 = ["disabled"];
const _hoisted_31 = { class: "report-list-options report-permission-users-content" };
const _hoisted_32 = ["onClick"];
const _hoisted_33 = { style: { "margin-top": "4px", "margin-bottom": "4px" } };
const _hoisted_34 = { class: "fst-italic" };
const _hoisted_35 = { key: 1 };
const _hoisted_36 = { class: "col-xs-12 col-sm-12 col-md-5 ps-0" };
const _hoisted_37 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_b_button = _resolveComponent("b-button");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tUser Permissions for Reports\r\n\t\t\t\t")
            ], -1 /* CACHED */)),
            _cache[8] || (_cache[8] = _createTextVNode()),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.save,
                        disabled: !_ctx.hasChanges
                    }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                _createTextVNode(" Save\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick", "disabled"]),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.cancel,
                        disabled: !_ctx.hasChanges
                    }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createTextVNode(" Cancel\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick", "disabled"])
                ])
            ])
        ]),
        _cache[28] || (_cache[28] = _createTextVNode()),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_multiselect, {
                            modelValue: _ctx.selectedCompanyId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                            options: _ctx.companies,
                            "track-by": "value",
                            label: "text",
                            showLabels: false,
                            placeholder: "Select a Company",
                            class: "multiselect-small"
                        }, {
                            noResult: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                ])
            ]),
            _cache[27] || (_cache[27] = _createTextVNode()),
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "x_title report-list-title" }, [
                                _createElementVNode("h3", { class: "m-0" }, "Report Types")
                            ], -1 /* CACHED */)),
                            _cache[11] || (_cache[11] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(['report-list-option', _ctx.isReportSelected(item) ? 'active' : '']),
                                            onClick: ($event) => (_ctx.selectReport(item))
                                        }, [
                                            _createElementVNode("div", _hoisted_16, _toDisplayString(item.reportName), 1 /* TEXT */)
                                        ], 10 /* CLASS, PROPS */, _hoisted_15));
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                ])
                            ])
                        ])
                    ]),
                    _cache[25] || (_cache[25] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "x_title report-list-title" }, [
                                _createElementVNode("h3", { class: "m-0" }, "Users")
                            ], -1 /* CACHED */)),
                            _cache[22] || (_cache[22] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_19, [
                                (_ctx.selectedReport != null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("div", _hoisted_22, [
                                                _createVNode(_component_b_form_checkbox, {
                                                    modelValue: _ctx.selectedReport.denyAccessToUsers,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedReport.denyAccessToUsers) = $event)),
                                                    size: "lg"
                                                }, {
                                                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tDefine Users allowed to access this report\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue"]),
                                                _cache[13] || (_cache[13] = _createTextVNode()),
                                                _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                                                    _createElementVNode("span", null, [
                                                        _createElementVNode("b", null, "Note:"),
                                                        _createTextVNode(" Assure client administrators have access to all reports.")
                                                    ])
                                                ], -1 /* CACHED */))
                                            ])
                                        ]),
                                        _cache[19] || (_cache[19] = _createTextVNode()),
                                        (_ctx.selectedReport.denyAccessToUsers)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                    _createElementVNode("div", _hoisted_25, [
                                                        _createElementVNode("div", _hoisted_26, [
                                                            _createElementVNode("div", _hoisted_27, [
                                                                _createElementVNode("label", _hoisted_28, "Selected: " + _toDisplayString(_ctx.selectedUsersCount), 1 /* TEXT */),
                                                                _cache[15] || (_cache[15] = _createTextVNode()),
                                                                _withDirectives(_createElementVNode("input", {
                                                                    class: "form-check-input ms-3 pt-2",
                                                                    style: { "margin-top": "8px" },
                                                                    type: "checkbox",
                                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.showOnlyUsersSelected) = $event)),
                                                                    disabled: _ctx.selectedUsersCount == 0
                                                                }, null, 8 /* PROPS */, _hoisted_29), [
                                                                    [_vModelCheckbox, _ctx.showOnlyUsersSelected]
                                                                ]),
                                                                _cache[16] || (_cache[16] = _createTextVNode()),
                                                                _createElementVNode("label", {
                                                                    class: "form-check-label mb-0 pt-2",
                                                                    disabled: _ctx.selectedUsersCount == 0
                                                                }, " Show only selected", 8 /* PROPS */, _hoisted_30)
                                                            ])
                                                        ])
                                                    ]),
                                                    _cache[17] || (_cache[17] = _createTextVNode()),
                                                    _createVNode(_component_b_form_input, {
                                                        modelValue: _ctx.userFilter,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.userFilter) = $event)),
                                                        modelModifiers: { trim: true },
                                                        placeholder: "Search for..."
                                                    }, null, 8 /* PROPS */, ["modelValue"])
                                                ]),
                                                _cache[18] || (_cache[18] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_31, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersFiltered, (item) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            class: _normalizeClass(['report-list-option', _ctx.isUserSelected(item) ? 'active' : '']),
                                                            onClick: ($event) => (_ctx.selectUser(item))
                                                        }, [
                                                            _createElementVNode("div", _hoisted_33, [
                                                                _createTextVNode(_toDisplayString(item.displayName) + " ", 1 /* TEXT */),
                                                                _createElementVNode("span", _hoisted_34, _toDisplayString(item.emailAddress ? `(${item.emailAddress})` : ''), 1 /* TEXT */)
                                                            ])
                                                        ], 10 /* CLASS, PROPS */, _hoisted_32));
                                                    }), 256 /* UNKEYED_FRAGMENT */))
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_35, [...(_cache[20] || (_cache[20] = [
                                            _createElementVNode("div", {
                                                class: "clearfix p-2",
                                                style: { "border": "1px solid #ced4da" }
                                            }, "\r\n\t\t\t\t\t\t\t\t\t\tSelect a Report\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]))
                            ])
                        ])
                    ]),
                    _cache[26] || (_cache[26] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_36, [
                        (((_a = _ctx.selectedReport) === null || _a === void 0 ? void 0 : _a.denyAccessToUsers) && _ctx.selectedUsersCount > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _cache[23] || (_cache[23] = _createElementVNode("label", null, "Selected user(s): ", -1 /* CACHED */)),
                                _cache[24] || (_cache[24] = _createTextVNode()),
                                _createElementVNode("span", null, _toDisplayString(_ctx.selectedUsersName), 1 /* TEXT */)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ])
        ]),
        _cache[29] || (_cache[29] = _createTextVNode()),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
